import logo from '../assets/messageAvatar.svg';
import { formatDateTime } from '../utils/helpers';
import PropTypes from 'prop-types';
import AudioPlayer from './AudioPlayer';
import { enhanceTextForTTS } from "../utils/helpers";

const Response = ({ text, inputMethod = 'text' }) => {
  const formattedText = enhanceTextForTTS(text, false);
  return (
      <div className='mb-3 mt-3'>
        <div className='max-w-[100%]'>
          <div className='grid mb-1'>
            <div className='flex justify-between items-center w-[90%] lg:w-[60%]'>
              <div className='flex items-center gap-2'>
                <img src={logo} alt='' />
                <p className='font-medium text-sm lg:text-base'>DELI</p>
              </div>
              <div className='flex items-center'>
                {text && <AudioPlayer
                    text={text}
                    autoPlay={inputMethod === 'voice'} // Only autoplay for voice input
                />}
                <p className='text-[#404C5E] text-sm lg:text-base ml-2'>{formatDateTime()}</p>
              </div>
            </div>
          </div>
          <div className='ml-10 grid'>
            {text ? (
                <div
                    className='link-highlight rounded-r-xl rounded-bl-xl p-5 bg-white w-[90%] lg:w-[60%]'
                    dangerouslySetInnerHTML={{ __html: formattedText }}
                />
            ) : (
                <p>
                  hmmm... It seems as if there are no listings that match your criteria. Try reframing your question or asking
                  a new one and I will do my best to provide you with the right properties.
                </p>
            )}
          </div>
        </div>
      </div>
  );
};

Response.propTypes = {
  text: PropTypes.string.isRequired,
  inputMethod: PropTypes.string
};

export default Response;